<template>
  <div>
    <div class="main-container">
      <div
        class="page-heading d-flex align-items-center justify-content-between"
      >
        <div class="main-head">
          <span>Preview Offer Letter</span>
        </div>
        <div class="d-flex align-items-center">
          <b-button class="addbtn pr-4 pl-4 pt-2 pb-2" v-b-modal.acceptmodal
            >Accept</b-button
          >
          <div class="rejectbtn">
            <b-button
              class="jdcancelbtn ml-3 pr-4 pl-4 pt-2 pb-2"
              v-b-modal.rejectmodal
              >Reject</b-button
            >
          </div>
        </div>
      </div>

      <div class="preview-container relativeclass mt-3">
        <div class="d-flex justify-content-center align-items-center">
          <div class="templatediv"></div>
        </div>
      </div>
    </div>
    <b-modal
      id="acceptmodal"
      size="md"
      centered
      hide-footer
      hide-header
      class="p-0"
    >
      <div
        class="modalheading d-flex align-items-center justify-content-between"
      >
        <span class="caution-txt">Acknowledgement</span>
      </div>
      <hr />
      <div class="modalcloseicon">
        <img src="../../assets/img/jddetails/modalclose.svg" alt="" />
      </div>
      <div>
        <div class="mt-3">
          <span class="accept-txt"> I accept the offer letter </span>
        </div>

        <div class="d-flex align-items-center justify-content-end mt-3">
          <b-button class="addbtn pr-4 pl-4">Respond</b-button>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="rejectmodal"
      size="md"
      centered
      hide-footer
      hide-header
      class="p-0"
    >
      <div
        class="modalheading d-flex align-items-center justify-content-between"
      >
        <span class="caution-txt">Acknowledgement</span>
      </div>
      <hr />
      <div class="modalcloseicon">
        <img src="../../assets/img/jddetails/modalclose.svg" alt="" />
      </div>
      <div>
        <div class="mt-3">
          <div class="rejectremark-box">
            Lorem ipsum, dolor sit amet consectetur adipisicing elit.
            Perspiciatis consequuntur asperiores quas ut praesentium ullam
            doloremque dignissimos, reiciendis dolorum. Fugit quisquam quas
            illum modi impedit error dignissimos atque voluptates repellat!
          </div>
        </div>

        <div class="d-flex align-items-center justify-content-end mt-3">
          <b-button class="addbtn pr-4 pl-4">Respond</b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "PreviewOfferLetter",
  data() {
    return {};
  },
  methods: {
    previewAppointmentLetter() {
      this.$bvModal.show("appointmentLetter");
    },
    closeAppointmentLetter() {
      this.$bvModal.hide("appointmentLetter");
    },
    acceptButton() {
      this.$bvModal.show("acceptAppointmentLetter");
    },
    closeAcceptedModal() {
      this.$bvModal.hide("acceptAppointmentLetter");
    },
    rejectButton() {
      this.$bvModal.show("rejectAppointmentLetter");
    },
    closeRejectedModal() {
      this.$bvModal.hide("rejectAppointmentLetter");
    },
    acceptedButton() {
      this.$bvModal.hide("acceptAppointmentLetter");
      this.$router.push({ name: "EmployeeregistrationForm" });
    },
  },
};
</script>

<style>
.accept-txt {
  font-weight: 400;
  font-size: 14px;
  color: #8a8b8c;
}
.jdcancelbtn:hover {
  border-radius: 3px;
  color: var(--bg-tertiary);
  background-color: var(--bg-white);
  font-size: var(--size-13);
  border: 1px solid var(--btn-border);
}
.rejectbtn .btn-secondary:not(:disabled):not(.disabled):active {
  color: var(--bg-tertiary);
  background-color: var(--bg-white);
  border-color: none !important;
}
.rejectbtn .btn-secondary:focus,
.btn-secondary.focus {
  color: var(--bg-tertiary);
  background-color: var(--bg-white);
  border-color: none;
  box-shadow: none;
}
.templatediv {
  background: #fbfbfb;
  border: 0.5px solid #e5e5e5;
  box-sizing: border-box;
  box-shadow: 0px 0px 20px rgba(86, 86, 86, 0.2);
  border-radius: 5px;
  height: calc(100vh - 205px);
  margin: 10px 0px;
  width: 50%;
  overflow: auto;
}
.preview-container {
  background: #ffffff;
  border-radius: 8px;
  padding: 15px;
  height: calc(100vh - 165px);
}
.modalcloseicon {
  position: absolute;
  top: -15px;
  right: -15px;
}
.rejectremark-box {
  background: #fcfcfc;
  border: 0.5px solid #c4c4c4;
  box-sizing: border-box;
  box-shadow: inset 0px 0px 3px rgba(0, 0, 0, 0.25);
  border-radius: 3px;
  height: 120px;
  overflow: auto;
  font-weight: 400;
  font-size: 13px;
  color: #6d6d6d;
}
</style>
